export default __webpack_public_path__ + "static/media/chat_mobile.5abd63af.svg";